import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";

import {
	acceptedTerms,
	initialOnboarding,
	updateOnboardFieldRequest,
	validateInitialOnboardingEmail,
} from "../../../store/modules/register/actions";

import { ButtonTerms, Col, Container, Content, FormGroupInput, FormSubmit, Group, Subtitle, Title } from "../styles";

import { Button, Checkbox, Input } from "../../../shared/components";
import { validateEmail } from "../../../utils/validator";

import HttpService from "../../../services/HttpService";
import history from "../../../services/history";

import Recaptcha from "../../../components/Recaptcha";

const ConfirmationEmail = () => {
	const dispatch = useDispatch();

	const { loading, initialOnboardingResponseData } = useSelector((state) => state.register);

	const { register, watch, setError, clearErrors, formState } = useForm();
	const { emailCreateAccount } = watch();

	const [acceptTerms, setAcceptTerms] = useState(false);
	const [editable, setEditable] = useState(false);
	const [disable, setDisable] = useState(true);
	const [isValidCaptcha, setIsValidCaptcha] = useState(false);
	const [tokenRecaptcha, setTokenRecaptcha] = useState(null);

	const onboardAbandoned = (e) => {
		HttpService.setAbandonedOnboardStatus();
		sessionStorage.setItem("IS_ABANDONADED", true);
	};

	useEffect(() => {
		if (sessionStorage.getItem("IS_ABANDONADED") && !sessionStorage.getItem("GO_BACK"))
			history.push("/onboard/login");

		window.addEventListener("popstate", onboardAbandoned);
		window.addEventListener("beforeunload", onboardAbandoned);

		if (!sessionStorage.getItem("IS_ABANDONADED")) dispatch(initialOnboarding());

		const { unsubscribe } = watch((value, { name }) => {
			const isEmailValid = validateEmail(value[name]);

			value[name] && value[name].length > 5 && !isEmailValid
				? setError(name, { message: "Verifique o seu e-mail" })
				: clearErrors(name);

			setDisable((value[name] && value[name].length <= 5) || !isEmailValid);
		});

		return () => {
			unsubscribe();

			window.removeEventListener("beforeunload", onboardAbandoned);
			window.removeEventListener("popstate", onboardAbandoned);
			if (document.location.pathname === "/onboard/login") {
				HttpService.setAbandonedOnboardStatus();
				sessionStorage.setItem("IS_ABANDONADED", true);
			}
		};
	}, []);

	function sendCode() {
		dispatch(
			validateInitialOnboardingEmail(
				initialOnboardingResponseData.cd_access_token,
				"e-mail",
				emailCreateAccount,
				tokenRecaptcha
			)
		);
	}

	const updateField = () => {
		if (emailCreateAccount) {
			dispatch(updateOnboardFieldRequest("email", emailCreateAccount, null, editable));
		}
	};

	const handleTerm = (value) => {
		setAcceptTerms(value);
		dispatch(acceptedTerms(value));

		if (value) {
			dispatch(updateOnboardFieldRequest("accept_term", value, null));
		}
	};

	return (
		<Container>
			<Content>
				<Col>
					<Title>Criar uma conta</Title>
					<Subtitle>
						Para sua própria segurança, informe seu{" "}
						<span style={{ color: "var(--brand-primary)" }}>
							e-mail
						</span>{" "}
						para receber um código de verificação.
					</Subtitle>
				</Col>
				<FormGroupInput>
					<Input
						label="E-mail"
						placeholder="nome@exemplo.com"
						fieldRegister="emailCreateAccount"
						register={register}
						required={true}
						autoFocus={true}
						errorMessage={formState.errors.emailCreateAccount}
						onFocus={({ currentTarget }) => {
							if (
								currentTarget.value.length > 5 &&
								validateEmail(currentTarget.value)
							) {
								setEditable(true);
							}
						}}
						onBlur={({ currentTarget }) => {
							if (currentTarget.value.length) updateField();
						}}
					/>
				</FormGroupInput>

				<Group>
					<Checkbox
						checked={acceptTerms}
						onChange={() => handleTerm(!acceptTerms)}
					>
						<span>
							Aceito os&nbsp;
							<ButtonTerms
								href={
									"https://trademap.com.br/termos-de-uso-e-politica-de-privacidade"
								}
								target="_blank"
							>
								Termos de Uso e Política de Privacidade
							</ButtonTerms>
						</span>
					</Checkbox>
				</Group>

				<Recaptcha
					isValid={(param) => setIsValidCaptcha(param)}
					token={setTokenRecaptcha}
				/>

				<FormSubmit>
					<Button
						title="Enviar código"
						disabled={
							!acceptTerms ||
							Object.keys(formState.errors).length ||
							!isValidCaptcha ||
							disable
						}
						onClick={() => sendCode()}
						loading={loading}
					></Button>
				</FormSubmit>
			</Content>
		</Container>
	);
};

export default ConfirmationEmail;
